// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3SCZo","search":"Settings_search__1b_hA","filter":"Settings_filter__2lRUs"};